import React from "react";

import { useGetObjectDataset } from "api/api-hooks/object-dataset-hooks";
import useCurrentCompanyContext from "hooks/useCurrentCompanyContext";
import ObjectDatasetCommon from "./components/ObjectDatasetCommon";
import ObjectDatasetGeneral from "./components/ObjectDatasetGeneral";
import "./object-dataset-styles.scss";
import { ObjectDatasetConfig } from "./object-dataset-types";

export default function ObjectDataset(props: ObjectDatasetConfig) {
  const company = useCurrentCompanyContext();

  const { data } = useGetObjectDataset(props.identifier ?? "", company?.companyReference ?? "", {
    enabled: !!company?.companyReference && !!props.identifier,
    retry: false,
    refetchOnWindowFocus: false,
  });

  return (
    <>
      {data?.type !== "GENERAL" && <ObjectDatasetCommon data={data} {...props} />}
      {data?.type === "GENERAL" && (
        <ObjectDatasetGeneral
          data={data}
          loadConf={props.loadConf}
          rows={props.rows}
          showDelete={props.showDeleteButton}
        />
      )}
    </>
  );
}
